import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { StudentDetailsParents } from "../components/StudentDetailsParents";
import { useMemo } from "react";

export const StudentParentsContainer = () => {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    const parents = useMemo(() => data?.parents?.filter((parent) => ['MOM', 'DAD'].includes(parent?.parentType)), [data])

    return (
        <StudentDetailsParents parents={parents as any} />
    );
}
